<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DateRangeMixin from "@/mixins/DateRangeMixin";
import DepartmentService from "@/services/DepartmentService";
import VFilters from "@/components/Search/VFilters";
import MessagesMixin from "@/mixins/Messages";
import TaskService from "@/services/TaskService";
import VMissingDays from "@/views/Reports/components/VMissingDays";

export default {
    name: "VPersonalMultiview",
    mixins: [DateRangeMixin, MessagesMixin],
    components: {
        VFilters,
        DateRangePicker,
        VMissingDays
    },
    data() {
        return {
            loading: true,
            showModal: false,
            context: null,
            data: [],
            deps: []
        };
    },
    computed: {
        currentExportUrl: function() {
            let url = new URL(
                location.protocol +
                    "//" +
                    location.host +
                    "/v1/tasks/clock-project-report"
            );
            url.searchParams.append("csv", 1);
            let params = this.$buildParams();

            for (let param in params) {
                if (param == "dateRange") {
                    url.searchParams.append(
                        param,
                        JSON.stringify(params[param])
                    );
                } else {
                    if (Array.isArray(params[param])) {
                        params[param].forEach(function(value) {
                            url.searchParams.append(param + "[]", value);
                        });
                    } else {
                        url.searchParams.append(param, params[param]);
                    }
                }
            }

            return url.href;
        }
    },
    async created() {
        this.resetSearch();
        this.$apiEnableWatcher();
        await this.fetchDepartments(true);
        await this.fetchData();
    },
    methods: {
        async fetchData() {
            if (this.apiSearchFilter.dateRange.startDate === null) {
                this.loading = false;
                return;
            }

            try {
                this.loading = true;
                let params = this.$buildParams();
                const { data } = await TaskService.GET_clockProjectReport(
                    params
                );

                this.data = data.data;
            } catch (e) {
                console.log("e fetchData", e);
            }

            this.loading = false;
        },
        async fetchDepartments(loading = false) {
            try {
                this.loading = true;
                const r = await DepartmentService.dropdown();
                this.deps = r.data.data;
            } catch (e) {
                console.log("fetchDepartments e", e);
            }

            this.loading = loading;
        },
        resetSearch() {
            this.apiSearchFilter = {
                dateRange: {
                    startDate: null,
                    endDate: null
                }
            };
        },
        /**
         * Close details modal
         */
        closeDetails() {
            this.context = null;
            this.showModal = false;
        },
        /**
         * Open details modal with not clsoed days
         */
        showDetails(stat, noregs) {
            this.context = { stat, noregs };
            this.showModal = true;
        }
    }
};
</script>

<template>
    <div class="v-personal-multiview">
        <base-header class="pb-1" type=""><bread-bag></bread-bag></base-header>
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <card body-classes="px-0">
                        <!-- V-FILTERS -->
                        <div class="px-4 mb-4">
                            <v-filters
                                :search="false"
                                :start-open="true"
                                :enable-filters="true"
                                @reset-search="resetSearch"
                                @filter-view-change="$handleFilterView($event)"
                            >
                                <!-- Default slot starts here -> filters -->
                                <div class="col-12 col-md-3">
                                    <date-range-picker
                                        class="range-picker"
                                        ref="picker"
                                        opens="right"
                                        :timePicker="false"
                                        :showWeekNumbers="true"
                                        :autoApply="true"
                                        v-model="apiSearchFilter.dateRange"
                                        :linkedCalendars="true"
                                        :locale-data="
                                            getDateRangePickerLocale()
                                        "
                                        :ranges="getDateRangePickerRanges()"
                                    >
                                        <template #header>
                                            <manual-range
                                                :date-range-manual="
                                                    dateRangeManual
                                                "
                                                :date-range-error="
                                                    dateRangeError
                                                "
                                                @exec="
                                                    execManualRange(
                                                        'apiSearchFilter',
                                                        'dateRange'
                                                    )
                                                "
                                            />
                                        </template>
                                        <template
                                            v-slot:input="picker"
                                            style="min-width: 350px"
                                        >
                                            <template v-if="picker.startDate">
                                                {{
                                                    $d(
                                                        picker.startDate,
                                                        "short"
                                                    )
                                                }}
                                                -
                                                {{
                                                    $d(picker.endDate, "short")
                                                }}
                                            </template>
                                        </template>
                                    </date-range-picker>
                                </div>
                                <div class="col-12 col-md-3">
                                    <FormulateInput
                                        type="select"
                                        :options="deps"
                                        v-model="apiSearchFilter.department_id"
                                        :placeholder="
                                            $t(
                                                'stats.placeholder_select_department'
                                            )
                                        "
                                    />
                                </div>
                                <div class="col-12 col-md-3">
                                    <div
                                        style="margin-top: 14px"
                                        v-if="data.length"
                                    >
                                        <a :href="currentExportUrl" class=""
                                            ><i class="fa fa-file-csv"></i>
                                            {{
                                                $t(
                                                    "personal_multiview.export_as_csv"
                                                )
                                            }}</a
                                        >
                                    </div>
                                </div>
                                <div
                                    class="col-12 mt--3"
                                    v-if="
                                        apiSearchFilter.dateRange.startDate ===
                                            null
                                    "
                                >
                                    <div class="text-bold text-warning">
                                        {{
                                            $t(
                                                "personal_multiview.warn_select_dates"
                                            )
                                        }}
                                    </div>
                                </div>
                            </v-filters>
                        </div>

                        <!-- BODY -->
                        <v-loader :loading="loading" v-if="loading" />
                        <div v-else-if="data.length > 0">
                            <div class="px-4 text-bold text-warning mb-4">
                                <sup>*</sup> -
                                {{ $t("daylogs.star_text_explain_goal_clock") }}
                            </div>
                            <div class="table-r">
                                <v-table class="table table-mg table-sm">
                                    <v-thead>
                                        <v-tr>
                                            <v-th>{{
                                                $t("daylogs.tbl_hdr_name")
                                            }}</v-th>
                                            <v-th class="text-right text-warning"
                                                >{{ $t("daylogs.tbl_hdr_goal")
                                                }}<sup
                                                    class="text-bold "
                                                    >*</sup
                                                ></v-th
                                            >
                                            <v-th class="text-right">{{
                                                $t(
                                                    "daylogs.tbl_hdr_project_hours"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "daylogs.tbl_hdr_total_clock"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t("daylogs.tbl_hdr_work_hours")
                                            }}</v-th>

                                            <v-th class="text-right">{{
                                                $t(
                                                    "daylogs.tbl_hdr_vacation_days"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "daylogs.tbl_hdr_sick_leave_days"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "daylogs.tbl_hdr_other_absence_days"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "daylogs.tbl_hdr_off_work_hours"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "daylogs.tbl_hdr_balance_current_period"
                                                )
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "daylogs.tbl_hdr_balance_global"
                                                )
                                            }}</v-th>
                                        </v-tr>
                                    </v-thead>
                                    <v-tbody>
                                        <v-tr
                                            v-for="entry in data"
                                            :key="entry.id"
                                        >
                                            <v-td>{{ entry.name }} </v-td>

                                            <v-td class="text-right">
                                                {{
                                                    entry.total_goal_time
                                                        | toTime
                                                }}
                                                <div
                                                    class="text-muted small"
                                                    v-if="true"
                                                >
                                                    ~{{
                                                        entry.period_goal
                                                            | toTime
                                                    }}
                                                </div></v-td
                                            >
                                            <v-td class="text-right">{{
                                                entry.time_projects | toTime
                                            }}</v-td>
                                            <v-td class="text-right">{{
                                                entry.time_total | toTime
                                            }}</v-td>
                                            <v-td class="text-right">{{
                                                entry.time_clock | toTime
                                            }}</v-td>

                                            <v-td class="text-right"
                                                >{{
                                                    $n(entry.days_holiday_time)
                                                }}
                                                <div class="small text-muted">
                                                    {{
                                                        entry.time_absence_holiday
                                                            | toTime
                                                    }}
                                                </div></v-td
                                            >
                                            <v-td class="text-right"
                                                >{{ $n(entry.days_sick_time) }}
                                                <div class="small text-muted">
                                                    {{
                                                        entry.time_absence_sick
                                                            | toTime
                                                    }}
                                                </div></v-td
                                            >
                                            <v-td class="text-right"
                                                >{{
                                                    $n(entry.days_others_time)
                                                }}
                                                <div class="small text-muted">
                                                    {{
                                                        entry.time_absence_others
                                                            | toTime
                                                    }}
                                                </div></v-td
                                            >
                                            <v-td class="text-right">{{
                                                entry.time_off | toTime
                                            }}</v-td>
                                            <v-td class="text-right">{{
                                                entry.time_diff | rTime
                                            }}</v-td>
                                            <v-td class="text-right">
                                                {{
                                                    entry.global_balance | rTime
                                                }}
                                            </v-td>
                                        </v-tr>
                                    </v-tbody>
                                </v-table>
                            </div>
                        </div>
                        <div class="px-4" v-else>
                            <div class="alert alert-warning">
                                {{ $t("personal_multiview.no_results_found") }}
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
        <portal to="modals">
            <v-missing-days
                :context="context"
                v-if="showModal"
                @close="closeDetails"
            />
        </portal>
    </div>
</template>

<style></style>
